@if (!skeletonView) {
  <app-scrollable-list [count]="additionalFields.length">
    @for (additions of additionalFields; track additions) {
      <div class="addition">
        <div class="addition-key">{{ additions.key }}</div>
        <div class="addition-value">{{ additions.value }}</div>
      </div>
    }
  </app-scrollable-list>
} @else {
  <ngx-skeleton-loader [count]="1" [theme]="{ height: '100px' }"></ngx-skeleton-loader>
}
